import { Theme, applyTheme } from '@cloudscape-design/components/theming';

export const primaryButtonGreen = '#56dac5';
export const primaryGreenDarker = '#00a28f';
const secondaryButtonGrey = '#e2e6ea';
const darkGrey = '#1e1e1e';
const fontSize = '1em';
const headingConst = '14px';
const backgroundTheme =
  'radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#62d29e]/40 via-[#62d29e]/20 to-white';
export const themeObject: Theme = {
  tokens: {
    colorBackgroundLayoutMain: {
      // Specify value for light and dark mode
      light:
        'radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#62d29e]/40 via-[#62d29e]/20 to-white'
      // light: 'blue'
    },
    // font sizing and line heights
    // fontSizeBodyM: '0.9em',
    // fontSizeBodyS: '0.9em',
    // fontSizeDisplayL: fontSize,
    // fontSizeHeadingXl: headingConst,
    // fontSizeHeadingL: headingConst,
    // fontSizeHeadingM: headingConst,
    // fontSizeHeadingS: headingConst,
    // fontSizeHeadingXs: headingConst,
    // fontWeightHeadingXl: fontSize,
    // fontWeightHeadingL: fontSize,
    // fontWeightHeadingM: fontSize,
    // fontWeightHeadingS: fontSize,
    // fontWeightHeadingXs: fontSize,
    // lineHeightBodyM: '1em',
    // lineHeightBodyS: '1em',
    // lineHeightBodyS: fontSize,
    // lineHeightDisplayL: fontSize,
    // lineHeightHeadingXl: fontSize,
    // lineHeightHeadingL: fontSize,
    // lineHeightHeadingM: fontSize,
    // lineHeightHeadingS: fontSize,
    // lineHeightHeadingXs: fontSize,

    // borderRadiusContainer: '10px',
    // borderRadiusButton: '1px',
    // // colorTextButtonNormalActive: 'green',
    // // colorBackgroundButtonNormalDefault: 'green',
    // // primary buttons
    colorTextButtonPrimaryDefault: 'white',
    colorBackgroundButtonPrimaryDefault: primaryButtonGreen,
    colorBackgroundButtonPrimaryHover: primaryGreenDarker,

    colorBackgroundButtonPrimaryActive: primaryButtonGreen,
    colorTextButtonNormalActive: 'white', // when clicking on button
    colorBackgroundButtonNormalActive: primaryButtonGreen,
    // // normal buttons
    colorTextButtonNormalDefault: primaryButtonGreen, // normal button
    // colorBackgroundButtonNormalDefault: secondaryButtonGrey, // non selected button
    colorBorderButtonNormalDefault: primaryButtonGreen,
    colorTextButtonNormalHover: 'white',
    colorBorderButtonNormalHover: primaryButtonGreen,
    colorBackgroundButtonNormalHover: primaryButtonGreen,
    colorBorderItemSelected: primaryButtonGreen,

    // colorBackgroundContainerContent: '#f4f5f7',
    // colorBackgroundContainerHeader: '#f4f5f7',
    // // fontSizeDisplayL: '30px',
    // // fontSizeHeadingXl: '20px',
    // // lineHeightHeadingXl: '24px',
    // // fontSizeBodyM: '13px',
    // colorBackgroundCellShaded: '#c4cdd5',
    // colorBorderItemSelected: '#c4cdd5',
    // colorBackgroundItemSelected: '#c4cdd5', //table row border
    // colorBackgroundControlChecked: darkGrey, //select radio buttons and table selectiojns
    // // colorForegroundControlDefault: 'salmon', // the dots etc check mark for above
    // // colorBackgroundStatusSuccess: 'red',
    // // colorBorderDividerSecondary: 'lightBlue',
    // colorBorderDividerDefault: '#d1d5db', // outlines of containers and table etc
    // // colorTextBodyDefault: 'brown',
    // // colorTextHeadingDefault: 'brown'
    // // colorTextBr
    // colorTextBreadcrumbCurrent: 'black',
    // colorTextBreadcrumbIcon: 'black'
    // colorBackgroundContainerContent: backgroundTheme
    colorBackgroundControlChecked: {
      light: primaryButtonGreen,
      dark: primaryButtonGreen
    }
  }
};
